import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useSubmitImprovement = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitImprovement = useCallback(async ({ idOffer } = {}) => {
    if (!idOffer) {
      toast.error('Offer ID is required.');
      return false;
    }

    const token = getAuthToken();
    if (!token) {
      toast.error('Authentication required. Please login again.');
      return false;
    }

    setIsSubmitting(true);
    try {
      await axios.post(
        `${api.API_URL}/procurement/ImprovementClarificationSubmitImprovement`,
        { idOffer },
        {
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success('Improvement submitted successfully.');
      return true;
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to submit improvement.';
      toast.error(message);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submitImprovement, isSubmitting };
};

export default useSubmitImprovement;
